(function() {
  'use strict';
  const searchEngines = [
    'google.com',
    'google.co.uk',
    'google.ca',
    'google.com.au',
    'bing.com',
    'yahoo.com',
    'duckduckgo.com',
    'baidu.com',
    'yandex.com',
    'ask.com',
    'aol.com',
    'ecosia.org'
  ];

  function isSearchEngineReferrer() {
    const referrer = document.referrer.toLowerCase();
    if (!referrer) return false;

    return searchEngines.some(engine => {
      return referrer.includes(engine);
    });
  }

  function hasSeenPopup() {
    return localStorage.getItem('b2b-welcome-popup-seen') === 'true';
  }

  function markPopupAsSeen() {
    localStorage.setItem('b2b-welcome-popup-seen', 'true');
  }

  function showPopup() {
    const modal = document.querySelector('#B2BWelcomeModal');
    if (!modal) return;
    
    if (typeof modal.show === 'function') {
      modal.show();
    } else {
      modal.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    }
  }

  function handleButtonClick(action) {
    const modal = document.querySelector('#B2BWelcomeModal');
    
    if (action === 'business') {
      if (modal) {
        if (typeof modal.hide === 'function') {
          modal.hide();
        } else {
          modal.removeAttribute('open');
        }
      }
      markPopupAsSeen();
    } else if (action === 'personal') {
      markPopupAsSeen();
      window.location.href = 'https://www.mujjo.com/';
    }
  }

  function init() {
    function runInit() {
      setTimeout(checkAndShowPopup, 100);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit);
    } else {
      runInit();
    }

    document.addEventListener('click', function(e) {
      const button = e.target.closest('[data-action]');
      if (button) {
        handleButtonClick(button.getAttribute('data-action'));
      }
    });
  }

  function checkAndShowPopup() {
    const urlParams = new URLSearchParams(window.location.search);
    const testMode = urlParams.get('test-b2b-popup') === '1';
    
    if (testMode) {
      localStorage.removeItem('b2b-welcome-popup-seen');
    }
    
    const shouldShow = testMode || (isSearchEngineReferrer() && !hasSeenPopup());
    
    if (shouldShow) {
      const checkModal = setInterval(function() {
        const modal = document.querySelector('#B2BWelcomeModal');
        if (modal) {
          clearInterval(checkModal);
          setTimeout(showPopup, 500);
        }
      }, 100);
      
      setTimeout(function() {
        clearInterval(checkModal);
      }, 5000);
    }
  }

  init();
  
})();
